import { OwnerInfoRecord } from "Interfaces/OwnerInfo";
import { Actions } from "../ArrivingGuestInfo/types";
import { HopperInfoAction, HopperInfoState, InitState } from "./types";

export const HopperHomeReducer = (
  state: HopperInfoState,
  action: HopperInfoAction
): HopperInfoState => {
  const { type, payload } = action;

  const InitOwnerInfo: OwnerInfoRecord = {
    cieId: 0,
    ownerNumber: "",
    firstName: "",
    middleName: "",
    lastName: "",
    sourceSystem: "",
    memberships: [],
    ownerBenefitLevels: [],
    email: "",
    phone: {
      code: "",
      phoneNumber: "",
    },
  };

  switch (type) {
    case Actions.SETDATA:
      return {
        ...state,
        ownerInfo: payload.ownerInfo ? payload.ownerInfo : InitOwnerInfo,
      };

    case Actions.ERROR:
      return {
        ...state,
        ownerInfoErrorCode: payload.code ? payload.code : '',
      }

    case Actions.API_LOADING:
      return {
        ...state,
        ownerInfo: payload
      }

    default:
      return InitState;
  }
};
